import pull from 'lodash/pull';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

class ControlsPanel extends PureComponent {
  render() {
    const { activeColumns, columns, onClick } = this.props;
    const keys = pull(Object.keys(activeColumns), 'name', 'games', 'time');

    return (
      <div className="x-stat-table-togglers">
        {
          keys.map((key) => {
            const className = [
              'button',
              'button--sm',
              activeColumns[key] ? 'button-primary' : '',
            ].join(' ');

            const column = columns.find(column => [column.id, column.accessor].indexOf(key) !== -1);
            const title = column.Header.props.children;

            return (
              <button
                className={className}
                data-key={key}
                key={key}
                onClick={onClick}
              >
                {title || ''}
              </button>
            );
          })
        }
      </div>
    );
  }
}

ControlsPanel.propTypes = {
  /**
   * Columns statuses
   */
  activeColumns: PropTypes.object.isRequired,

  /**
   * Columns params
   */
  columns: PropTypes.array.isRequired,

  /**
   * Click handler
   */
  onClick: PropTypes.func.isRequired,
}

export default ControlsPanel;
